var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrain = function SvgTrain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 8,
    r: 4.5,
    fill: "currentColor",
    stroke: "#363846"
  })));
};
export default SvgTrain;